/**
 * Revam Mobile Menu (GTG-012) - JavaScript Controller
 * Handles all interactions for the mobile hamburger menu
 * Supports 3-level deep navigation: Main Menu → Submenu → Sub-submenu
 */

(function() {
  'use strict';
  if (window.__revamMobileMenuInit) return;
  window.__revamMobileMenuInit = true;

  // DOM Elements
  let menuOverlay = null;
  let closeButtons = null;
  let menuTriggers = null;
  let navButtons = null;
  let backButtons = null;
  let submenuPanels = null;
  
  // State - track submenu stack for multi-level navigation
  let submenuStack = []; // Array of active submenus (supports infinite levels)
  let isOpen = false;
  let scrollPosition = 0;

  /**
   * Initialize the mobile menu
   */
  function init() {
    // Cache DOM elements
    menuOverlay = document.querySelector('.mobile-menu-overlay');
    
    if (!menuOverlay) {
      return;
    }

    closeButtons = document.querySelectorAll('.mobile-menu__close');
    menuTriggers = document.querySelectorAll('[data-mobile-menu-trigger]');
    navButtons = document.querySelectorAll('[data-has-submenu="true"]');
    backButtons = document.querySelectorAll('.mobile-menu__back-btn');
    submenuPanels = document.querySelectorAll('.mobile-menu__submenu-panel');

    // Bind events
    bindEvents();
    initFeaturedProgress();
  }

  /**
   * Top Choice horizontal-scroll progress indicator
   */
  function initFeaturedProgress() {
    var scroller = menuOverlay.querySelector('[data-featured-scroll]');
    var bar = menuOverlay.querySelector('[data-featured-progress]');
    if (!scroller || !bar) return;
    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      var ratio = max > 0 ? scroller.scrollLeft / max : 0;
      // bar represents the visible viewport proportion, min 25%
      var visible = scroller.scrollWidth > 0 ? scroller.clientWidth / scroller.scrollWidth : 1;
      var width = Math.max(0.25, visible);
      bar.style.width = (width * 100) + '%';
      bar.style.marginLeft = (ratio * (1 - width) * 100) + '%';
    }
    scroller.addEventListener('scroll', update, { passive: true });
    update();
  }

  /**
   * Bind all event listeners
   */
  function bindEvents() {
    // Menu triggers (hamburger icons)
    menuTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', openMenu);
    });

    // Close buttons
    closeButtons.forEach(function(button) {
      button.addEventListener('click', closeMenu);
    });

    // Navigation buttons with submenus (works for all levels)
    navButtons.forEach(function(button) {
      button.addEventListener('click', openSubmenu);
    });

    // Back buttons in submenus - prevent event bubbling
    backButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.stopPropagation(); // Prevent click from bubbling to overlay
        closeCurrentSubmenu(e);
      });
    });

    // Close on escape key
    document.addEventListener('keydown', handleKeyDown);

    // Close on overlay click (if clicking the background, not the menu content)
    menuOverlay.addEventListener('click', function(e) {
      if (e.target === menuOverlay) {
        closeMenu();
      }
    });

    // Prevent clicks inside menu screens from bubbling to overlay
    var menuScreens = menuOverlay.querySelectorAll('.mobile-menu__screen, .mobile-menu__submenu-panel');
    menuScreens.forEach(function(screen) {
      screen.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    });

    // Handle touch events for swipe to close
    // Note: Swipe gestures are disabled to prevent conflicts with horizontal scrolling
    // Users can close the menu via the X button or clicking outside the menu
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    let touchStartTarget = null;

    menuOverlay.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
      touchStartTarget = e.target;
    }, { passive: true });

    menuOverlay.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      handleSwipe(e);
    }, { passive: true });

    function handleSwipe(e) {
      const swipeThreshold = 100;
      const swipeDistanceX = touchStartX - touchEndX;
      const swipeDistanceY = Math.abs(touchStartY - touchEndY);
      
      // Check if the touch started on a horizontally scrollable element
      // (collections scroll, or the "Top Choice" featured row). If so, don't
      // treat the gesture as a swipe-to-close — it's the user scrolling the row.
      var scrollableParent = touchStartTarget ? touchStartTarget.closest('.mobile-menu__collections-scroll, .mobile-menu__content, .mobile-menu__submenu-content, .mobile-menu__featured, .mobile-menu__featured-scroll') : null;
      if (scrollableParent) {
        // Don't close menu when swiping inside scrollable areas
        return;
      }
      
      // Only process horizontal swipes (not vertical scrolling)
      // Horizontal distance must be greater than vertical distance
      if (swipeDistanceY > Math.abs(swipeDistanceX) * 0.5) {
        return; // This looks like a vertical scroll, not a horizontal swipe
      }
      
      // Swipe left to close main menu when no submenu is open
      if (swipeDistanceX > swipeThreshold && submenuStack.length === 0) {
        closeMenu();
      }
      
      // Swipe right to go back one level
      if (swipeDistanceX < -swipeThreshold && submenuStack.length > 0) {
        closeCurrentSubmenu();
      }
    }
  }

  /**
   * Open the mobile menu
   */
  function openMenu() {
    if (isOpen) return;
    
    isOpen = true;
    scrollPosition = window.pageYOffset;

    // Lock body scroll
    document.body.classList.add('mobile-menu-open');
    document.body.style.top = -scrollPosition + 'px';

    // Show menu
    menuOverlay.classList.add('is-open');
    menuOverlay.classList.remove('is-closing');

    // Set focus to close button for accessibility
    setTimeout(function() {
      var firstCloseBtn = menuOverlay.querySelector('.mobile-menu__close');
      if (firstCloseBtn) {
        firstCloseBtn.focus();
      }
    }, 300);

    // Announce to screen readers
    menuOverlay.setAttribute('aria-hidden', 'false');

    // Dispatch custom event
    document.dispatchEvent(new CustomEvent('mobileMenu:opened'));
  }

  /**
   * Close the mobile menu
   */
  function closeMenu() {
    if (!isOpen) return;

    // Close all open submenus first
    closeAllSubmenus();

    // Add closing animation class
    menuOverlay.classList.add('is-closing');
    menuOverlay.classList.remove('is-open');

    // Wait for animation to complete
    setTimeout(function() {
      isOpen = false;
      menuOverlay.classList.remove('is-closing');

      // Unlock body scroll
      document.body.classList.remove('mobile-menu-open');
      document.body.style.top = '';
      window.scrollTo(0, scrollPosition);

      // Announce to screen readers
      menuOverlay.setAttribute('aria-hidden', 'true');

      // Return focus to trigger
      var trigger = document.querySelector('[data-mobile-menu-trigger]');
      if (trigger) {
        trigger.focus();
      }

      // Dispatch custom event
      document.dispatchEvent(new CustomEvent('mobileMenu:closed'));
    }, 300);
  }

  /**
   * Open a submenu panel (works for any level)
   */
  function openSubmenu(e) {
    e.preventDefault();
    
    var button = e.currentTarget;
    var targetId = button.getAttribute('data-submenu-target');
    var submenuPanel = document.querySelector('[data-submenu-id="' + targetId + '"]');

    if (!submenuPanel) return;

    // Push to stack
    submenuStack.push({
      panel: submenuPanel,
      triggerButton: button
    });
    
    submenuPanel.classList.add('is-active');

    // Set focus to back button
    setTimeout(function() {
      var backBtn = submenuPanel.querySelector('.mobile-menu__back-btn');
      if (backBtn) {
        backBtn.focus();
      }
    }, 300);

    // Announce to screen readers
    submenuPanel.setAttribute('aria-hidden', 'false');
    button.setAttribute('aria-expanded', 'true');
  }

  /**
   * Close the current (topmost) submenu and go back one level
   */
  function closeCurrentSubmenu(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation(); // Prevent event from bubbling up to overlay
    }

    if (submenuStack.length === 0) return;

    // Pop the top submenu from stack
    var current = submenuStack.pop();
    current.panel.classList.remove('is-active');

    // Set focus back to the button that opened this submenu
    setTimeout(function() {
      if (current.triggerButton) {
        current.triggerButton.focus();
        current.triggerButton.setAttribute('aria-expanded', 'false');
      }
    }, 300);

    // Announce to screen readers
    current.panel.setAttribute('aria-hidden', 'true');
  }

  /**
   * Close all submenus (used when closing the entire menu)
   */
  function closeAllSubmenus() {
    while (submenuStack.length > 0) {
      var current = submenuStack.pop();
      current.panel.classList.remove('is-active');
      current.panel.setAttribute('aria-hidden', 'true');
      if (current.triggerButton) {
        current.triggerButton.setAttribute('aria-expanded', 'false');
      }
    }
  }

  /**
   * Handle keyboard navigation
   */
  function handleKeyDown(e) {
    if (!isOpen) return;

    // Escape key
    if (e.key === 'Escape' || e.keyCode === 27) {
      if (submenuStack.length > 0) {
        closeCurrentSubmenu();
      } else {
        closeMenu();
      }
      e.preventDefault();
    }

    // Tab key - trap focus within menu
    if (e.key === 'Tab' || e.keyCode === 9) {
      trapFocus(e);
    }
  }

  /**
   * Trap focus within the menu for accessibility
   */
  function trapFocus(e) {
    // Get the current active container (topmost submenu or main menu)
    var container = submenuStack.length > 0 
      ? submenuStack[submenuStack.length - 1].panel 
      : menuOverlay;
      
    var focusableElements = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );

    if (focusableElements.length === 0) return;

    var firstElement = focusableElements[0];
    var lastElement = focusableElements[focusableElements.length - 1];

    if (e.shiftKey && document.activeElement === firstElement) {
      lastElement.focus();
      e.preventDefault();
    } else if (!e.shiftKey && document.activeElement === lastElement) {
      firstElement.focus();
      e.preventDefault();
    }
  }

  /**
   * Public API
   */
  window.RevamMobileMenu = {
    init: init,
    open: openMenu,
    close: closeMenu,
    toggle: function() {
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    },
    isOpen: function() {
      return isOpen;
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
